module.exports = __webpack_public_path__ + "img/havefun_title_sc.6766fda9.jpg";